import { SignalWifiBad, SignalWifiStatusbar4Bar, SignalWifiStatusbarConnectedNoInternet4 } from '@mui/icons-material';
import { Box, Fade } from '@mui/material';
import { palette, theme } from '@silbo/ui';
import { useEffect, useState } from 'react';
import { useBandwidthContext } from '../contexts/BandwidthContext';

export type BandwidthIconPlacement = 'bottom-left' | 'top-right';

type BandwidthIconProps = {
  placement?: BandwidthIconPlacement;
};

const PLACEMENT_STYLES: Record<BandwidthIconPlacement, Record<string, number | string>> = {
  'bottom-left': {
    bottom: 16,
    left: 16,
  },
  'top-right': {
    top: 'calc(env(safe-area-inset-top, 0px) + 12px)',
    right: 16,
  },
};

const BandwidthIcon = ({ placement = 'bottom-left' }: BandwidthIconProps) => {
  const { status } = useBandwidthContext();
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (status === 'online') {
        setVisible(true);
      } else {
        setVisible(!visible);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [visible, status]);

  const ICON_MAPPING = {
    online: {
      component: () => <SignalWifiStatusbar4Bar />,
      color: 'success.main',
    },
    unstable: {
      component: () => <SignalWifiStatusbarConnectedNoInternet4 sx={{ fontSize: 20 }} />,
      color: 'warning.main',
    },
    offline: {
      component: () => <SignalWifiBad sx={{ fontSize: 20 }} />,
      color: 'error.main',
    },
  };

  return (
    <Fade in={visible}>
      <Box
        sx={{
          position: 'fixed',
          ...PLACEMENT_STYLES[placement],
          border: `${status === 'online' ? '1px' : '2px'} solid`,
          borderRadius: '50%',
          width: status === 'online' ? 30 : 40,
          height: status === 'online' ? 30 : 40,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderColor: ICON_MAPPING[status].color,
          bgcolor: palette.background.default,
          zIndex: theme.zIndex.appBar + 1,
        }}
        color={ICON_MAPPING[status].color}
      >
        {ICON_MAPPING[status].component()}
      </Box>
    </Fade>
  );
};

export default BandwidthIcon;
